<template>
  <div class="login-wrapper">
    <el-form
      :model="userLoginInfo"
      class="login-info "
      label-width="100px"
      ref="loginForm"
    >
      <div class="login-info-title">
        Backstage Login
      </div>
      <div class="login-info-subtitle">
        Only provide to ucfunnel colleague!!!
      </div>
      <el-form-item
        style="margin-top: 96px"
        label="Email"
        :prop="'email'"
        :rules="stringRule('email')"
      >
        <el-input
          class="login-info-input"
          v-model="userLoginInfo.email"
          placeholder="please input your email"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="Password"
        :prop="'password'"
        :rules="stringRule('Password')"
      >
        <el-input
          class="login-info-input"
          v-model="userLoginInfo.password"
          placeholder="please input your passsword"
          show-password
        ></el-input>
      </el-form-item>
      <div class="login-info-option">
        <el-button
          @click="loginWithUserServer()"
          class="login-info-option-login"
          >Login</el-button
        >
      </div>
    </el-form>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import MixFormRule from "@/components/mixins/formRule";
export default {
  name: "login",
  mixins: [MixFormRule],
  data() {
    return {
      userLoginInfo: {
        email: "",
        password: "",
        service: "RichMedia",
      },
    };
  },
  methods: {
    ...mapActions({
      init: "init",
      backstageLogin: "user/backstageLogin",
    }),
    async loginWithUserServer() {
      this.init();
      try {
        let res = await this.$refs.loginForm.validate();
        await this.backstageLogin(this.userLoginInfo);
        const auth = Vue.prototype.$cookies.get("auth");
        if (auth) {
          this.$router.push("/backstage_creator_management");
        }
      } catch (e) {
        console.error(e);
        Vue.prototype.$notify.error({
          title: "Error",
          message: e.response.data.message,
          position: "bottom-right",
          offset: 20,
          duration: 3000,
        });
      }
    },
  },
};
</script>
<style lang="sass" scoped>
.login-theme
  &-font
    color: $color-blue

.login-wrapper
  .login-info
    width: 400px
    padding: 16px
    z-index: 1
    background: white
    &-switch
      font-size: 14px
      text-align: right
      display: flex
      justify-content: flex-end
      .pointer
        cursor: pointer
    &-title
      margin: 4px 0px 24px
      display: flex
      justify-content: center
      color: $color-blue
      font-size: 24px
      text-align: center
    &-subtitle
      margin: 4px 0px 24px
      display: flex
      justify-content: center
      color: $color-blue
      font-size: 16px
    &-option
      margin-top: 12px
      display: flex
      justify-content: flex-end
      &-login
        width:100%
        background-color: $color-blue
        color: white
        margin-top: 30px
    ::v-deep .el-form-item__label
      text-align: left
    ::v-deep .el-form-item__error
      margin-left: 16px
  h1
    color: $color-blue
    text-align: center
  .btn
    position: relative
    display: block
    border: none
    cursor: pointer
    outline: none
    left: 50%
    transform: translateX(-50%)
  .login-btn
    font-size: 18px
    font-weight: 400
    color: $color-white
    background-color: $color-blue
    border-radius: 30px
    padding: 10px
    text-align: center
    width: 150px
    text-decoration: none
</style>
